import { Component, OnInit, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NewsService } from '../rest/api/news.service';
import * as moment from 'moment';
import {TranslateService} from '@ngx-translate/core';
import { GalleryService } from '../rest/api/gallery.service';
import { PageService } from '../rest';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-top-page',
  templateUrl: './top-page.component.html',
  styleUrls: ['./top-page.component.scss']
})
export class TopPageComponent implements OnInit, OnDestroy {
  categoryId = '';
  keywords = '';
  languageData: any;
  newsList: any;
  menuList: any;
  galleryList: any;
  socialList: any;
  prodData: any;
  functionData: any;
  lang: any;
  itemsPerPage = 6;
  currentPage = 1;
  private destroy$ = new Subject<void>();
  private routerSubscription: any;

  constructor(
    private route: ActivatedRoute,
    public newsService: NewsService,
    public galleryService: GalleryService,
    public translateService: TranslateService,
    public pageService: PageService,
    public router: Router,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    this.routerSubscription = this.router.events.pipe(
      takeUntil(this.destroy$)
    ).subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
         // trick the Router into believing it's last link wasn't previously loaded
         this.router.navigated = false;
         // if you need to scroll back to top, here is the right place
         window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.getAllNewsList();
    this.getAllGalleryList(this.currentPage, this.itemsPerPage, '', '');
    this.getMenuDetails();
    this.languageData = this.route.snapshot.data.language;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  getAllGalleryList(page, limit, categoryId, keywords) {
    this.galleryService.getGalleryList({
      page: page,
      paginate: limit,
      category: categoryId || undefined,
      keywords: keywords || undefined,
      lang: this.lang
    }).pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: any) => {
      this.galleryList = response.data;
      this.galleryList = _.orderBy(this.galleryList, ['published_date'], ['desc']);
    }, err => {
      console.log(err && err.error);
    });
  }

  getAllNewsList() {
    const limit = 4;
    const page = 1;

    this.newsService.getNewsList({
      page: page,
      paginate: limit,
      lang: this.lang
    }).pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: any) => {
      this.newsList = response.data;
      this.newsList = _.orderBy(this.newsList, ['published_at'], ['desc']);
    }, err => {
      console.log(err && err.error);
    });
  }

  getMonth(data) {
    const check = moment(data.published_at, 'YYYY/MM/DD');
    const month = check.format('MMM');
    return month;
  }

  getDate(data) {
    const check = moment(data.published_at, 'YYYY/MM/DD');
    const day   = check.format('D');
    return day;
  }

  getMenuDetails() {
    this.pageService.getMenuList(this.lang).pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: any) => {
      const menuData = response.data;
      this.prodData = _.find(menuData, ['slug', 'production']);
      this.functionData = _.find(menuData, ['slug', 'function']);
    }, err => {
      this.prodData = [];
      this.functionData = [];
      this.router.navigate(['/']);
    });
  }
}

